import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import ImportFileModal from "./actions/import_file_modal"
import FilesTable from "./components/table"
import showAsperaWarning from "@helpers/showAsperaWarning"
import { sharedPackageAndZipDownload } from "../../redux/api/download_link/zip_downloads"

class Package extends React.Component {
  constructor() {
    super()

    this.state = {}
  }

  render() {
    const { download, packageSize, status } = this.props

    const handleZip = () => {
      sharedPackageAndZipDownload(download._id, (error) => { console.error('error preparing zip ', error)})
    }

    return (
      <div>
        <h3 className='mb1 flex items-center justify-between'>
          <span>Shared Files: {download.project_title}</span>
          {status === "READY" && (
            <button className='cs-button white flex items-center' onClick={handleZip}>
              <i className='material-icons mr1'>folder</i> Download All
            </button>
          )}
        </h3>
        {download.method !== "aspera" && showAsperaWarning(download.file_objects) &&
          <div className='border border-gray-5 bg-white rounded p2 my2 flex items-center'>
            <span className={`material-icons green mr1`}>info</span>
              <div className='flex-col'>
              <span>If this content includes a DCP or large file structure, use the <b>Download All</b> button above to download a zip package containing the full structure.</span><br />
              <span>If you have issues with the zip download, please contact the sender to request an Aspera link, which is better suited for these types of files.</span>
              </div>
          </div>}
        <FilesTable/>
        <ImportFileModal/>
      </div>
    )
  }
}

Package.propTypes = {
  download: PropTypes.object.isRequired,
  packageSize: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired
}

const mapStateToProps = state => ({
  download: state.download_link,
  packageSize: state.download_link.files.list.reduce((p, c) => {
    return p + c.size
  }, 0),
  status: state.download_link.files.status
})

export default connect(mapStateToProps)(Package)
